module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "common-footer-wrap"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollY > 200),
      expression: "scrollY > 200"
    }],
    staticClass: "return-top",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("返回顶部")])]), _vm._v(" "), _c('div', {
    staticClass: "app-footer",
    class: {
      'app-footer-mobile': !_vm.isPc(), 'app-footer-contact-page': _vm.isContactPage()
    }
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v(" 凡卓集团 COPY­RIGHT (©) 2023  沪ICP备18033374号-2 ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-footer"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/fzg-logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("融资服务")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:bp@xfz.cn"
    }
  }, [_vm._v("bp@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:bd@xfz.cn"
    }
  }, [_vm._v("bd@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:media@xfz.cn"
    }
  }, [_vm._v("media@xfz.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("简历投递")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:hr@xfz.cn"
    }
  }, [_vm._v("hr@xfz.cn")])])]), _vm._v(" "), _c('div', {
    staticClass: "phone-area"
  }, [_c('a', {
    staticClass: "phone",
    attrs: {
      "href": "tel:010-85870086 "
    }
  }, [_vm._v(" 电话：010-85870086 ")]), _vm._v(" "), _c('a', {
    staticClass: "address",
    attrs: {
      "href": "https://j.map.baidu.com/3e/8sf",
      "target": "_blank"
    }
  }, [_vm._v(" 地址：北京市朝阳区凤凰置地广场F座8层")]), _vm._v(" "), _c('div', {
    staticClass: "wechat-line"
  }, [_c('div', {
    staticClass: "wechat-item"
  }, [_c('img', {
    staticClass: "wchat-icon",
    attrs: {
      "src": "https://static-image.xfz.cn/1685923644886/wechat.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wechat-qrcode",
    attrs: {
      "src": "https://static-image.xfz.cn/1697973893660/pc-qr.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5799368a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FooterPc.vue
// module id = 228
// module chunks = 0